/* Upsell (instant tick): add -> show “Added ✓” immediately -> collapse; repaint runs in background */
(function(){
  if (window.__XSELL_TICK__) return; window.__XSELL_TICK__ = true;

  const FEEDBACK = { addDelayMS: 350, tickMS: 1600};

  const SEL = {
    drawerRoot : '#cart-drawer, .js-drawer.drawer, .cart-drawer, .drawer--cart, .drawer, .ajaxcart, .mini-cart, .side-cart',
    itemsWrap  : '[data-cart-container]',
    itemsInner : '.ajaxcart__inner, .ajaxcart_inner',
    addBtn     : '.cs-add, [data-cs-upsell-add], [data-variant-id]',
    upsellWrap : '#cs-upsell, .drawer-upsell, .cart-cross-sell, .cross-sell, .upsell',
    upsellCard : '.cs-card,[data-variant-id]',
    titleAny   : '[data-upsell-title], .upsell-heading',
    removeBtn  : '.ajaxcart__remove, [data-action="remove"], a[href*="/cart/change"], button[name="remove"]',
    priceRow   : '.cs-price',
    savePill   : '.cs-badge'
  };

  const $  = (s,r)=> (r||document).querySelector(s);
  const $$ = (s,r)=> Array.from((r||document).querySelectorAll(s));
  const drawer       = ()=> $(SEL.drawerRoot);
  const itemsBox     = ()=> drawer() && drawer().querySelector(SEL.itemsWrap);
  const itemsInner   = ()=> drawer() && drawer().querySelector(SEL.itemsInner);
  const insideDrawer = el => !!(drawer() && el && drawer().contains(el));
  const getVid       = el => { const c = el.closest('[data-variant-id]'); return c ? Number(c.getAttribute('data-variant-id')) : 0; };
  const getPid       = el => { const c = el.closest('[data-product-id]'); return c ? String(c.getAttribute('data-product-id')) : null; };
  const log          = (...a)=> console.log('[xsell]', ...a);

  /* ---------- tracking ---------- */
  function publishShopify(event, payload){
    try{ if (window.Shopify?.analytics?.publish) { Shopify.analytics.publish(event, payload); return true; } }catch(_){}
    try{ if (window.Shopify?.analytics?.lib?.track){ Shopify.analytics.lib.track(event, payload); return true; } }catch(_){}
    return false;
  }
  function track(event, payload){
    publishShopify('custom_'+event, payload);
    try{ (window.dataLayer = window.dataLayer || []).push({event:'upsell_'+event, ...payload}); }catch(_){}
    try{ document.dispatchEvent(new CustomEvent('upsell:'+event, {detail: payload})); }catch(_){}
  }

  function ensureLiveRegion(){
    const host = drawer() || document.body;
    if (!host) return;
    let lr = host.querySelector('#upsell-live');
    if (!lr){
      lr = document.createElement('div');
      lr.id = 'upsell-live';
      lr.setAttribute('aria-live','polite');
      lr.style.position='absolute'; lr.style.left='-9999px'; lr.style.height='1px'; lr.style.overflow='hidden';
      host.appendChild(lr);
    }
    return lr;
  }
  function announce(msg){ const lr=ensureLiveRegion(); if(lr){ lr.textContent=''; setTimeout(()=>lr.textContent=msg,10); } }

  /* ---------- cart ops ---------- */
  async function addToCart(id, qty){
    const fd = new FormData(); fd.append('id', String(id)); fd.append('quantity', String(qty||1));
    const r = await fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:fd});
    if(!r.ok){ let m='Add to cart failed'; try{const j=await r.json(); if(j?.description)m=j.description;}catch(_){ }
      throw new Error(m);
    }
  }


/* add this helper just above pokeNativeRefreshers() */
function _fmtMoney(c){
  try { return Shopify.formatMoney(c, ""); }
  catch(e){ return (c/100).toFixed(2); }
}
function repaintLinePrices(cart){
  var rows = document.querySelectorAll('.ajaxcart__line-item, [data-line]');
  (cart.items || []).forEach(function(item, i){
    var line = i + 1;
    var row  = document.querySelector('[data-line="'+ line +'"]') || rows[i];
    if (!row) return;
    var wrap = row.querySelector('.ajaxcart__product-price-wrapper');
    if (!wrap) return;

    var hasDiscount = (item.original_line_price > item.final_line_price);
    var hasCompare  = (item.original_price > item.price); // true compare-at on variant

    var html;
    if (hasDiscount){
      var strike = hasCompare ? item.original_line_price : item.line_price; // fallback when no real compare_at
      html = '<del class="ajaxcart__price ajaxcart__price--regular">'+ _fmtMoney(strike) +'</del>' +
             '<span class="ajaxcart__price ajaxcart__price--sale">'+ _fmtMoney(item.final_line_price) +'</span>';
    } else if (hasCompare){
      html = '<del class="ajaxcart__price ajaxcart__price--regular">'+ _fmtMoney(item.original_line_price) +'</del>' +
             '<span class="ajaxcart__price ajaxcart__price--sale">'+ _fmtMoney(item.line_price) +'</span>';
    } else {
      html = '<span class="ajaxcart__price">'+ _fmtMoney(item.line_price) +'</span>';
    }
    wrap.innerHTML = html;
  });
}


  function pokeNativeRefreshers(){
    ['cart:refresh','cart:change','cart:updated','afterAddToCart','ajaxProduct:added']
      .forEach(name => { try{ document.dispatchEvent(new CustomEvent(name,{bubbles:true})); }catch(_){ } });
      try {
    fetch('/cart.js', {credentials:'same-origin'})
      .then(r => r.json())
      .then(cart => { repaintLinePrices(cart); });
  } catch(_) {}

    try{ if (window.ajaxCart?.loadCart){ ajaxCart.loadCart(); } else if (window.ajaxCart?.load){ ajaxCart.load(); } }catch(_){}
    try{ if (window.ajaxCart?.refresh ){ ajaxCart.refresh();  } }catch(_){}
    try{ if (window.AjaxCart?.refresh ){ AjaxCart.refresh();  } }catch(_){}
    try{ if (window.theme?.ajaxCart?.render){ theme.ajaxCart.render(); } }catch(_){}
    try{ if (window.theme?.CartDrawer?.refresh){ theme.CartDrawer.refresh(); } }catch(_){}
    try{ if (window.CartDrawer?.refresh){ CartDrawer.refresh(); } }catch(_){}
    try{ if (window.appco?.cart?.render){ appco.cart.render(); } }catch(_){}
  }

 // --- helper: fetch cart then repaint line prices ---
function _fetchCartAndRepaint(){
  fetch('/cart.js', {credentials:'same-origin'})
    .then(r => r.json())
    .then(repaintLinePrices)
    .catch(function(){});
}

/* ---------- Money helper ---------- */
function _fmt(cents){
  try { return Shopify.formatMoney(cents, ""); }
  catch(e){ return (cents/100).toFixed(2); }
}

/* ---------- Repaint per-line price wrappers ---------- */
function repaintLinePrices(cart){
  try{
    var wraps = document.querySelectorAll('.ajaxcart__product-price-wrapper');
    if (!wraps.length || !cart || !cart.items) return;

    wraps.forEach(function(wrap, i){
      var item = cart.items[i];
      if (!item) return;

      // per-unit values straight from cart.js
      var unit = item.price;                 // e.g. 2299
      var unitCompare = item.original_price; // e.g. 3299, 0 if none
      var hasCompare = unitCompare && unitCompare > unit;

      var del  = wrap.querySelector('del.ajaxcart__price--regular');
      var sale = wrap.querySelector('span.ajaxcart__price--sale');
      var base = (!sale && !del) ? wrap.querySelector('.ajaxcart__price') : null;

      if (hasCompare){
        if (!del){
          del = document.createElement('del');
          del.className = 'ajaxcart__price ajaxcart__price--regular';
          wrap.insertBefore(del, wrap.firstChild);
        }
        if (!sale){
          sale = document.createElement('span');
          sale.className = 'ajaxcart__price ajaxcart__price--sale';
          wrap.appendChild(sale);
        }
        del.textContent  = _fmt(unitCompare);
        sale.textContent = _fmt(unit);
        if (base) base.remove();
      } else {
        if (sale) sale.remove();
        if (del)  del.remove();
        if (!base){
          base = document.createElement('span');
          base.className = 'ajaxcart__price';
          wrap.appendChild(base);
        }
        base.textContent = _fmt(unit);
      }
    });
  }catch(_){}
}

/* ---- hook into ajaxCart drawer refresh ---- */
(function () {
  if (!window.ajaxCart || !ajaxCart.load) return;

  var _load = ajaxCart.load;
  ajaxCart.load = function() {
    var out = _load.apply(this, arguments);
    // after drawer re-renders, fire a single event
    setTimeout(function(){ document.dispatchEvent(new Event('cart:refresh')); }, 0);
    return out;
  };
})();

/* ---- repaint price wrapper whenever drawer refreshes ---- */
document.addEventListener('cart:refresh', function () {
  fetch('/cart.js', {credentials:'same-origin'})
    .then(function(r){ return r.json(); })
    .then(repaintLinePrices)   // uses the helper you already have
    .catch(function(){});
});

/* ---- fallback: if a qty click doesn't trigger ajaxCart.load, still repaint ---- */
document.addEventListener('click', function (e) {
  var hit = e.target && e.target.closest(
    'button.ajaxcart__qty_adjust.ajaxcart__qty--plus,'  +
    'button.ajaxcart__qty_adjust.ajaxcart__qty--minus,' +
    '.wpbingo-qty_adjust--plus,' +
    '.wpbingo-qty_adjust--minus'
  );
  if (!hit) return;
  setTimeout(function(){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(repaintLinePrices)
      .catch(function(){});
  }, 350);
});

document.addEventListener('change', function (e) {
  if (!e.target.matches('input.ajaxcart__qty-num, input.wpbingo-qty_number, input[name^="updates"]')) return;
  setTimeout(function(){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(repaintLinePrices)
      .catch(function(){});
  }, 350);
});





 

  function headerSectionId(){
    let el = drawer();
    while (el && el !== document.documentElement){
      if (el.id && el.id.startsWith('shopify-section-')) return el.id.replace('shopify-section-','');
      el = el.parentElement;
    }
    const hdr = document.querySelector('[id^="shopify-section-"][id*="header"]');
    return hdr ? hdr.id.replace('shopify-section-','') : null;
  }
  function reopenDrawer(){
    try{ if (window.theme?.CartDrawer?.open) { theme.CartDrawer.open(); return; } }catch(_){}
    try{ if (window.CartDrawer?.open)       { CartDrawer.open(); return; } }catch(_){}
    document.dispatchEvent(new CustomEvent('cart:open',{bubbles:true}));
  }

  function moveSavePills(){
    let moves = 0;
    $$(SEL.upsellCard, document).forEach(card=>{
      const pill  = card.querySelector(SEL.savePill);
      const price = card.querySelector(SEL.priceRow);
      if (pill && price && !price.contains(pill)){
        pill.style.position = 'static';
        price.appendChild(pill);
        moves++;
      }
    });
    if (moves) log('moved save pills:', moves);
  }

  function swapInnerFromHTML(sectionHTML){
    const doc = new DOMParser().parseFromString(sectionHTML,'text/html');
    const donor = doc.querySelector(SEL.itemsInner);
    const live  = itemsInner();
    if (donor && live){
      live.innerHTML = donor.innerHTML;
      log('inner swap -> items:', donor.children ? donor.children.length : 0);
      return true;
    }
    return false;
  }

  async function repaintViaSection(){
    const id = headerSectionId(); if (!id) return false;
    const res = await fetch('/?section_id='+encodeURIComponent(id), {credentials:'same-origin', cache:'no-store'});
    if (!res.ok) return false;
    const html = await res.text();

    const host = document.getElementById('shopify-section-'+id); if (!host) return false;
    host.outerHTML = html;
    reopenDrawer();

    setTimeout(()=>{ swapInnerFromHTML(html); attachCartObserver(); moveSavePills(); }, 40);
    return true;
  }

  /* ---------- visibility sync ---------- */
  let syncTimer=null, cartMO=null;
  function scheduleSync(){ clearTimeout(syncTimer); syncTimer=setTimeout(syncFromCart,120); }

  async function getCartJSON(){
    try{ return await fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(r=>r.json()); }
    catch(_){ return null; }
  }

  async function syncFromCart(){
    const wrap = $(SEL.upsellWrap);
    const titles = $$(SEL.titleAny, document);
    const cart = await getCartJSON(); if (!cart) return;

    const inCart = new Set((cart.items||[]).map(i=>String(i.product_id)));
    let visible = 0;

    if (wrap){
      $$(SEL.upsellCard, wrap).forEach(card=>{
        const pid = String(card.getAttribute('data-product-id')||'');
        const hide = pid && inCart.has(pid);
        card.style.display = hide ? 'none' : '';
      });
      visible = $$(SEL.upsellCard, wrap).filter(c => c.style.display !== 'none').length;
      wrap.style.display = visible ? '' : 'none';
    }

    document.documentElement.setAttribute('data-upsell-empty', visible ? '0' : '1');
    titles.forEach(t => t.style.display = visible ? '' : 'none');

    try{
      const vis = $$(SEL.upsellCard, wrap).filter(c => c.style.display !== 'none');
      if (vis.length){
        const ids = vis.map(c => ({product_id: c.getAttribute('data-product-id'), variant_id: c.getAttribute('data-variant-id')}));
        track('impression', {items: ids});
      }
    }catch(_){}

    moveSavePills();
    log('upsell sync -> visible cards:', visible);
  }

  function collapseCard(card){
    if (!card) return;
    card.classList.add('cs-added');
    setTimeout(()=>{ try{ card.remove(); }catch(_){ } scheduleSync(); }, FEEDBACK.tickMS + 120);
  }

  function attachCartObserver(){
    try{ cartMO && cartMO.disconnect(); }catch(_){}
    const box = itemsBox(); if (!box) return;
    cartMO = new MutationObserver(()=> { scheduleSync(); moveSavePills(); });
    cartMO.observe(box, {childList:true, subtree:true});
  }

  /* ---------- clicks (with JITTER FIX) ---------- */
  document.addEventListener('click', function(e){
    const trigger = e.target.closest(SEL.addBtn);
    if (trigger && insideDrawer(trigger)){
      e.preventDefault(); e.stopImmediatePropagation();

      const card = trigger.closest(SEL.upsellCard);
      const vid  = getVid(trigger); if (!vid) return;
      const pid  = getPid(trigger);
      const btn  = trigger.tagName==='BUTTON' ? trigger : (trigger.closest('button')||trigger);
      const oldText = btn.textContent;

      // JITTER FIX A: freeze button width so label swaps don’t reflow
      const w = Math.ceil(btn.getBoundingClientRect().width);
      btn.style.width = w + 'px';
      btn.style.minWidth = w + 'px';
      btn.style.whiteSpace = 'nowrap';

      // JITTER FIX B: freeze the card height until we collapse it
      const cardH = card.offsetHeight;
      const prevTrans = card.style.transition;   // keep any inline transition
      card.style.height = cardH + 'px';
      card.style.overflow = 'hidden';
      card.style.transition = 'none';

      // optimistic: if last visible card, hide title immediately
      try{
        const wrap = document.querySelector(SEL.upsellWrap);
        if (wrap){
          const stillVisible = [...wrap.querySelectorAll(SEL.upsellCard)]
            .filter(c => c !== card && c.style.display !== 'none').length;
          if (stillVisible === 0) document.documentElement.setAttribute('data-upsell-empty','1');
        }
      }catch(_){}

      // feedback: only show “Adding…” if the call doesn't return quickly
      btn.disabled = true;
      let addingTimer = setTimeout(()=>{ btn.classList.add('is-adding'); btn.textContent='Adding…'; }, FEEDBACK.addDelayMS);

      (async () => {
        try{
          const t0 = performance.now();
          await addToCart(vid,1);

          // SUCCESS UI immediately
          clearTimeout(addingTimer);
          btn.classList.remove('is-adding');
          btn.disabled = false;
          const liveBtn = card.querySelector(SEL.addBtn) ? (card.querySelector(SEL.addBtn).closest('button')||btn) : btn;
          if (liveBtn){ liveBtn.classList.add('added-ok'); liveBtn.textContent = 'Added ✓'; }
          announce('Added to cart');

          // tracking
          track('add', {product_id: pid, variant_id: vid, ms: Math.round(performance.now()-t0)});

          // collapse after tick — first release card freeze so animation plays smoothly
          setTimeout(()=>{
            card.style.height = '';       // release height lock
            card.style.transition = prevTrans || '';  // restore any inline transition
            collapseCard(card);
          }, FEEDBACK.tickMS);

          // repaint in the background
          pokeNativeRefreshers();
          repaintViaSection();

          // restore button width lock if the card somehow persists; otherwise removal clears it
          setTimeout(()=>{
            if (document.body.contains(liveBtn)) {
              liveBtn.classList.remove('added-ok');
              liveBtn.textContent = oldText || 'Add';
              liveBtn.style.width = '';
              liveBtn.style.minWidth = '';
            }
          }, FEEDBACK.tickMS + 800);

        }catch(err){
          clearTimeout(addingTimer);
          btn.classList.remove('is-adding','added-ok');
          btn.disabled = false;
          btn.textContent = oldText || 'Add';

          // release freezes on error
          btn.style.width = '';
          btn.style.minWidth = '';
          card.style.height = '';
          card.style.transition = '';
          card.style.overflow = '';

          track('error', {variant_id: vid, message: (err?.message||'error')});
          console.warn('[xsell] add failed:', err?.message||err);
          alert(err?.message||'Could not add to cart');
        }
      })();
    }

    if (insideDrawer(e.target) && (e.target.closest(SEL.removeBtn) || e.target.closest('[name="updates[]"], [name="quantity"]'))){
      scheduleSync();
    }
  }, true);

  // keep pills placed even if upsell HTML reflows
  (function(){
    const root = $(SEL.upsellWrap);
    if (!root) return;
    const mo = new MutationObserver(()=> moveSavePills());
    mo.observe(root, {childList:true, subtree:true});
  })();

  // boot
  attachCartObserver();
  moveSavePills();
  scheduleSync();
})();














(function () {
  // --- money formatting helper (uses your shop's format if available) ---
  var MONEY_FORMAT = null;
  function formatMoney(cents){
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, MONEY_FORMAT);
    } catch(e){}
    var cur = (document.documentElement.getAttribute('data-shop-currency') || null) || 'GBP';
    return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format((cents||0)/100);
  }

  // --- render header badge (count + cost) ---
  function renderHeader(cart){
    if (!cart) return;
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });

    var money = formatMoney(cart.total_price);
    document.querySelectorAll('[data-cart-cost]').forEach(function(el){ el.textContent = money; });

    var hdr = document.querySelector('.header-cart');
    if (hdr) hdr.classList.toggle('is-empty', count === 0);
  }

  function refreshFromServer(){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(renderHeader)
      .catch(function(e){ console.warn('Cart badge refresh failed', e); });
  }

  // 1) initial load
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', refreshFromServer);
  } else {
    refreshFromServer();
  }

  // 2) listen to common custom events (many themes fire one of these)
  ['cart:updated','cart:refresh','ajaxCart:updated','drawer:cart:updated','updated.cart','cart:update']
  .forEach(function(evt){
    document.addEventListener(evt, function(e){
      var c = e && e.detail && (e.detail.cart || e.detail);
      if (c && typeof c === 'object' && 'item_count' in c) renderHeader(c); else refreshFromServer();
    });
  });

  // 3) patch fetch so ANY /cart/*.js call triggers a badge refresh
  var _fetch = window.fetch;
  window.fetch = function(input, init){
    var p = _fetch(input, init);
    try {
      var url = (typeof input === 'string') ? input : (input && input.url);
      if (url && /\/cart\/(add|change|update)\.js(\?|$)/.test(url)){
        p.then(function(){ refreshFromServer(); });
      }
    } catch(e){}
    return p;
  };
})();




































































(async function(){
  // 1) Try theme-provided country
  let iso = (window.Shopify && Shopify.country) ? Shopify.country : null;

  // 2) Try Shopify's public endpoint
  if(!iso) {
    try {
      const r = await fetch('/browsing_context_suggestions.json', {credentials:'same-origin'});
      if (r.ok) {
        const j = await r.json();
        iso = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle
              ? j.detected_values.country.handle.toUpperCase()
              : null;
      }
    } catch(e){}
  }

  // 3) Fallback: browser language
  if(!iso) {
    const lang = (navigator.language || '').toUpperCase();
    if (lang.startsWith('EN-GB')) iso = 'GB';
    else if (lang.startsWith('EN-AU') || lang.startsWith('EN-NZ')) iso = 'AU';
    else if (lang.startsWith('EN-CA') || lang.startsWith('FR-CA')) iso = 'CA';
    else if (lang.startsWith('EN-US') || lang.startsWith('ES-US')) iso = 'US';
    else if (lang.startsWith('EN-') || lang.startsWith('FR-') || lang.startsWith('DE-') || lang.startsWith('ES-') || lang.startsWith('IT-') || lang.startsWith('NL-')) iso = 'EU';
  }

  // Zones + thresholds (edit these numbers to your offer)
  const OFFER = {
    GB: { label: "UK",            cur: "£",  min: 35 },
    US: { label: "US",            cur: "$",  min: 45 },
    CA: { label: "Canada",        cur: "C$", min: 49 },
    EU: { label: "EU",            cur: "€",  min: 45 },
    AU: { label: "Australia/NZ",  cur: "A$", min: 59 }
  };

  // Country → Zone map
  const MAP = {
    GB:'GB', IM:'GB', JE:'GB', GG:'GB',
    US:'US',
    CA:'CA',
    IE:'EU', FR:'EU', DE:'EU', NL:'EU', ES:'EU', IT:'EU', BE:'EU', AT:'EU', SE:'EU', NO:'EU', CH:'EU', PT:'EU', DK:'EU', FI:'EU', PL:'EU', CZ:'EU',
    AU:'AU', NZ:'AU'
  };

  const zone = MAP[iso] || 'GB';
  const o = OFFER[zone] || OFFER.GB;

  const el = document.getElementById('free-ship-text');
  if (el) el.textContent = `Free ${o.label} shipping on orders ${o.cur}${o.min}+`;
})();












(function(){
  // Selectors for your header badge(s)
  var BADGE_SELECTOR = '[data-count-wishlist] .count, .wishlist-mobile .count, .icon-wishlist + .count';

  function $all(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  // Read wishlist count – tailored for Wpbingo, with fallbacks
  function readWishlistCount(){
    try {
      // Wpbingo commonly uses this key
      var v = localStorage.getItem('wpbingo_wishlist');
      if (v) { v = JSON.parse(v); if (Array.isArray(v)) return v.length; if (v && Array.isArray(v.items)) return v.items.length; }

      // Generic fallbacks some themes/apps use
      v = localStorage.getItem('wishlist');
      if (v) { v = JSON.parse(v); if (Array.isArray(v)) return v.length; if (v && Array.isArray(v.items)) return v.items.length; }

      v = localStorage.getItem('swym-wishlist');
      if (v) { v = JSON.parse(v); if (Array.isArray(v)) return v.length; if (v && typeof v.cnt === 'number') return v.cnt; }
    } catch(e){ /* ignore JSON errors */ }
    return 0;
  }

  function paint(){
    var n = readWishlistCount();
    $all(BADGE_SELECTOR).forEach(function(el){ el.textContent = n > 0 ? n : ''; });
  }

  // Ask the vendor (Wpbingo) to update itself if it exposes an API
  function vendorUpdate(){
    try {
      if (window.Wpbingo && Wpbingo.Wishlist) {
        if (typeof Wpbingo.Wishlist.updateCount === 'function') Wpbingo.Wishlist.updateCount();
        else if (typeof Wpbingo.Wishlist.init === 'function')    Wpbingo.Wishlist.init();
      }
    } catch(e){}
  }

  // Paint on first DOM ready and shortly after (to catch late script)
  document.addEventListener('DOMContentLoaded', function(){
    paint();
    setTimeout(function(){ vendorUpdate(); paint(); }, 150);
    setTimeout(paint, 600);
  });

  // If your performance loader broadcasts completion, repaint then too
  window.addEventListener('appco-scripts-loaded', function(){ vendorUpdate(); paint(); });

  // Repaint when wishlist changes (other tabs or app events)
  window.addEventListener('storage', function(e){ if (e && e.key && e.key.indexOf('wish') !== -1) paint(); });
  ['wishlist:add','wishlist:remove','swym:collections-updated','growave:wishlist:updated']
    .forEach(function(ev){ window.addEventListener(ev, paint); });
})();














    
  







  document.addEventListener('DOMContentLoaded', function(){
    var pl = document.getElementById('pre-loading');
    if (pl) setTimeout(function(){ pl.parentNode && pl.parentNode.removeChild(pl); }, 800);
  });


  





(function(){
  function wireCheckoutButtons(){
    document.querySelectorAll('.ajaxcart__footer .button-cart a[name="checkout"]').forEach(function(btn){
      if (btn.__spzWired) return;        // avoid duplicate listeners
      btn.__spzWired = true;
      btn.addEventListener('click', function(){
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy','true');
        // We do NOT prevent default; navigation proceeds,
        // spinner shows immediately on slow connections.
      }, {passive:true});
    });
  }

  // Run now, on DOM ready, and when drawer content changes
  if (document.readyState !== 'loading') wireCheckoutButtons();
  document.addEventListener('DOMContentLoaded', wireCheckoutButtons);

  // MutationObserver catches cart drawer re-renders
  new MutationObserver(wireCheckoutButtons)
    .observe(document.documentElement, {subtree:true, childList:true});
})();









(function () {
  if (window.__SP_CATS_ARROW_WIRED__) return;       // global guard
  window.__SP_CATS_ARROW_WIRED__ = true;

  // Find all arrow elements (adjust selector if your class differs)
  document.querySelectorAll('.select_category .icon-cate').forEach((arrow, idx) => {
    if (arrow.dataset.spBound === '1') return;      // per-element guard
    arrow.dataset.spBound = '1';

    // A11y + affordance
    arrow.setAttribute('role', 'button');
    arrow.setAttribute('tabindex', '0');

    // If the menu has an id, announce control
    const wrap = arrow.closest('.select_category');
    const menu = wrap && wrap.querySelector('.header-bottom__nav');
    if (menu && !menu.id) menu.id = 'cat-menu-' + (idx+1);
    if (menu) arrow.setAttribute('aria-controls', menu.id);

    // Click: delegate to the existing title handler
    arrow.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // avoid double-toggles if theme also listens upstream
      const title = wrap && wrap.querySelector('.select_category__title');
      if (title) title.click();
    });

    // Keyboard support (uses your existing handler)
    arrow.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      const title = wrap && wrap.querySelector('.select_category__title');
      if (title) title.click();
    });
  });
})();
